export type ComparatorSectionKey = string;

export const getDefaultCollapsedSections = ({
  embedded,
  initialIndicators,
  sectionKeys,
}: {
  embedded: boolean;
  initialIndicators: readonly string[];
  sectionKeys: Readonly<Record<ComparatorSectionKey, readonly string[]>>;
}): Record<ComparatorSectionKey, boolean> => {
  const sectionNames = Object.keys(sectionKeys);
  if (!embedded) {
    return Object.fromEntries(sectionNames.map((section) => [section, false]));
  }

  const selectableIndicators = new Set(initialIndicators);
  const expandedSections = new Set(
    sectionNames.filter((section) =>
      sectionKeys[section].some((key) => selectableIndicators.has(key)),
    ),
  );

  if (expandedSections.size === 0) {
    const firstSection = sectionNames.find(
      (section) => sectionKeys[section].length > 0,
    );
    if (firstSection) expandedSections.add(firstSection);
  }

  return Object.fromEntries(
    sectionNames.map((section) => [section, !expandedSections.has(section)]),
  );
};
